const OPEN_DATASETS_KEY = 'swa.openDatasets';

export const readStoredOpenDatasets = () => {
	if (typeof sessionStorage === 'undefined') {
		return [];
	}
	try {
		const parsed = JSON.parse(sessionStorage.getItem(OPEN_DATASETS_KEY) || '[]');
		if (!Array.isArray(parsed)) {
			return [];
		}
		return [...new Set(parsed.map(id => String(id)).filter(Boolean))];
	} catch {
		return [];
	}
};

export const persistOpenDatasets = openDatasets => {
	if (typeof sessionStorage === 'undefined') {
		return;
	}
	sessionStorage.setItem(OPEN_DATASETS_KEY, JSON.stringify(openDatasets));
};

export const openDataset = datasetId => ({
	type: 'OPEN_DATASET',
	datasetId: datasetId == null ? null : String(datasetId)
});

export const closeDataset = datasetId => ({
	type: 'CLOSE_DATASET',
	datasetId: datasetId == null ? null : String(datasetId)
});
